import { createFileRoute } from "@tanstack/react-router";
import YoungAdultDepressionTreatment from "@/pages/YoungAdultDepressionTreatment";
import {
  SITE_URL,
  buildBreadcrumbList,
  buildMedicalWebPage,
} from "@/components/schemaConstants";

const PAGE_URL = `${SITE_URL}/young-adult-depression-treatment`;
const BREADCRUMB_ID = `${PAGE_URL}#breadcrumb`;

export const Route = createFileRoute("/young-adult-depression-treatment")({
  head: () => ({
    meta: [
      {
        title:
          "Depression Treatment for Young Adults (18–25) in Coral Springs, FL | Neuro Wellness",
      },
      {
        name: "description",
        content:
          "Outpatient depression treatment for young adults 18–25: therapy, medication management, TMS and SPRAVATO®. Scheduling around school and work. Free consultation.",
      },
      {
        property: "og:title",
        content:
          "Depression Treatment for Young Adults (18–25) in Coral Springs, FL",
      },
      {
        property: "og:description",
        content:
          "Outpatient depression treatment for young adults 18–25 in Coral Springs. Therapy, medication management, TMS and SPRAVATO®. Free consultation.",
      },
      { property: "og:url", content: PAGE_URL },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: PAGE_URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildMedicalWebPage({
            name: "Depression Treatment for Young Adults in Coral Springs, FL",
            description:
              "Outpatient depression treatment for young adults 18–25: therapy, medication management, TMS and SPRAVATO®. Scheduling around school and work.",
            url: PAGE_URL,
            id: `${PAGE_URL}#webpage`,
            breadcrumbId: BREADCRUMB_ID,
          }),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildBreadcrumbList(
            [
              { name: "Home", href: "/" },
              {
                name: "Depression Treatment",
                href: "/depression-treatment-coral-springs",
              },
              {
                name: "Young Adults (18–25)",
                href: "/young-adult-depression-treatment",
              },
            ],
            BREADCRUMB_ID,
          ),
        ),
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <YoungAdultDepressionTreatment />;
}
